module.exports = __webpack_public_path__ + "img/semitrailer.9d607bb8.png";